// extracted by mini-css-extract-plugin
export default {"main":"Main_main__hBElm","mainBody__label":"Main_mainBody__label__nAk92","mainBody__title":"Main_mainBody__title__XH114","mainBody__cards":"Main_mainBody__cards__C7gIb"};